export default __webpack_public_path__ + "static/media/lb-ag.0e6f8672.webp";